if (!customElements.get('five-elements-offer')) {
  customElements.define('five-elements-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.checkboxes = [...this.querySelectorAll('[data-extra-variant]')];
      this.checkboxes.forEach(input => { input.disabled = input.dataset.available !== 'true'; });
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'ro', { style: 'currency', currency: 'RON', currencyDisplay: 'narrowSymbol' });
      this.onChange = event => {
        if (this.contains(event.target)) this.updateTotal();
        if (event.target.matches('[name="quantity"]') && this.isProductForm(event.target.form)) {
          this.productForms().forEach(form => {
            const input = form.querySelector('[name="quantity"]');
            if (input && input !== event.target) input.value = event.target.value;
          });
          this.updateTotal();
        }
      };
      this.onSubmit = event => {
        if (!this.isProductForm(event.target) || (!this.selected().length && this.dataset.handleAllSubmit !== 'true')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!this.form.reportValidity() || this.busy) return;
        this.addSelection(event.target);
      };
      document.addEventListener('change', this.onChange);
      document.addEventListener('input', this.onChange);
      document.addEventListener('submit', this.onSubmit, true);
      this.onClick = event => {
        const card = event.target.closest('.ks-five-elements__option');
        if (!card || !this.contains(card)) return;
        const dialog = card.querySelector('dialog');
        if (event.target.closest('[data-extra-open]')) dialog.showModal();
        if (event.target.closest('[data-extra-close]')) dialog.close();
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }
        const thumb = event.target.closest('[data-extra-image]');
        if (thumb) {
          const image = dialog.querySelector('.ks-extra-dialog-image');
          image.removeAttribute('srcset');
          image.src = thumb.dataset.extraImage;
          image.alt = thumb.dataset.extraAlt;
          dialog.querySelectorAll('[data-extra-image]').forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
        }
        if (event.target.closest('[data-extra-toggle]')) {
          const input = card.querySelector('[data-extra-variant]');
          if (input.disabled || this.busy) return;
          input.checked = !input.checked;
          this.updateTotal();
        }
      };
      this.addEventListener('click', this.onClick);
      this.updateTotal();
    }
    disconnectedCallback() {
      document.removeEventListener('change', this.onChange);
      document.removeEventListener('input', this.onChange);
      document.removeEventListener('submit', this.onSubmit, true);
      this.removeEventListener('click', this.onClick);
      this.initialized = false;
    }
    productForms() {
      return [this.form, ...document.querySelectorAll('.m-sticky-addtocart form')].filter(form => this.isProductForm(form));
    }
    isProductForm(form) {
      return form === this.form || (form?.closest('.m-sticky-addtocart') && form.querySelector('[name="id"]')?.value === this.dataset.mainVariant);
    }
    selected() { return this.checkboxes.filter(input => input.checked && !input.disabled); }
    quantity(form = this.form) { return Math.max(1, Number.parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10) || 1); }
    format(value) { return this.money.format(value / 100); }
    updateTotal() {
      const selected = this.selected();
      const key = 'duoPrice';
      const base = Number(this.dataset.mainPrice) * this.quantity();
      const total = base + selected.reduce((sum, input) => sum + Number(input.dataset[key]), 0);
      const original = base + selected.reduce((sum, input) => sum + Number(input.dataset.originalPrice), 0);
      this.querySelector('[data-offer-total]').textContent = this.format(total);
      const originalTotal = this.querySelector('[data-original-total]');
      originalTotal.textContent = this.format(original);
      originalTotal.hidden = original === total;
      const saving = this.querySelector('[data-offer-saving]');
      if (saving) {
        saving.textContent = saving.dataset.savingTemplate.replace('__AMOUNT__', this.format(original - total));
        saving.hidden = original === total;
      }
      this.checkboxes.forEach(input => {
        const card = input.closest('.ks-five-elements__option');
        card.querySelectorAll('[data-extra-price]').forEach(price => { price.textContent = '+ ' + this.format(Number(input.dataset[key])); });
        card.querySelectorAll('[data-extra-toggle]').forEach(button => {
          button.disabled = input.disabled || this.busy;
          button.setAttribute('aria-pressed', String(input.checked));
          button.querySelector('[data-extra-button-label]').textContent = input.checked ? this.dataset.selectedLabel : this.dataset.selectLabel;
        });
      });
      const list = this.querySelector('[data-selection-list]');
      const rows = [{label: this.dataset.mainLabel, quantity: this.quantity(), price: base}, ...selected.map(input => ({label:input.dataset.extraLabel, quantity:1, price:Number(input.dataset[key])}))];
      if (list) list.replaceChildren(...rows.map(row => {
        const item = document.createElement('li');
        const name = document.createElement('span');
        const price = document.createElement('strong');
        name.textContent = row.quantity + ' × ' + row.label;
        price.textContent = this.format(row.price);
        item.append(name, price);
        return item;
      }));
      const count = this.querySelector('[data-selection-count]');
      if (count) count.textContent = this.dataset.countTemplate.replace('__COUNT__', this.quantity() + selected.length);
      const heroSummary = this.closest('[data-ks-fe-landing]')?.querySelector('[data-hero-selection]');
      if (heroSummary) heroSummary.textContent = rows.map(row => row.quantity + ' × ' + row.label).join(' + ');
      this.productForms().forEach(form => {
        const accelerated = form.querySelector('.m-product-dynamic-checkout');
        if (accelerated) {
          accelerated.hidden = selected.length > 0;
          accelerated.toggleAttribute('data-ks-five-elements-hidden', selected.length > 0);
        }
      });
    }
    async addSelection(form) {
      this.busy = true;
      this.updateTotal();
      const message = this.querySelector('[data-offer-message]');
      message.hidden = true;
      const buttons = [...this.productForms().map(item => item.querySelector('[name="add"]')), ...this.querySelectorAll('[data-selection-submit]')].filter(Boolean);
      const states = buttons.map(button => button.disabled);
      buttons.forEach(button => { button.disabled = true; button.classList.add('m-spinner-button--loading'); });
      const properties = {};
      for (const [name, value] of new FormData(this.form)) {
        const match = name.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      const items = [{ id: Number(this.dataset.mainVariant), quantity: this.quantity(form), properties }, ...this.selected().map(input => ({ id: Number(input.dataset.extraVariant), quantity: 1 }))];
      const root = window.Shopify?.routes?.root || '/';
      let added = false;
      try {
        const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        added = true;
        const drawer = document.querySelector('m-cart-drawer');
        if (drawer && window.MinimogSettings?.enable_cart_drawer) {
          drawer.onCartDrawerUpdate();
          drawer.open(form.querySelector('[name="add"]'));
          const cart = await fetch(root + 'cart.js').then(response => response.json());
          drawer.updateCartCount(cart.item_count);
          if (window.MinimogTheme?.pubSubEvents?.cartUpdate) window.MinimogEvents?.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { ...cart, source: 'five-elements-offer' });
        } else {
          window.location.assign(root + 'cart');
        }
      } catch (error) {
        message.textContent = added ? this.dataset.success : error.message || this.dataset.error;
        message.hidden = false;
        if (added) window.location.assign(root + 'cart');
      } finally {
        buttons.forEach((button, index) => { button.disabled = states[index]; button.classList.remove('m-spinner-button--loading'); });
        this.busy = false;
        this.updateTotal();
      }
    }
  });
}
